"use strict";

import ListingFilterHandler from "./listing-filter-handler";
import ListingActionsHandler from "./listing-actions";
import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";

class ItemFetcherHandler {

	constructor(state, config, customHandlers) {

		this.state = state || ItemListingState;
		this.config = config || ItemListingConfig;
		this.handlers = {
			filterHandler: ListingFilterHandler,
			actions: ListingActionsHandler
		};


		if (typeof customHandlers === "object" && customHandlers) {
			for (const key of Object.keys(customHandlers)) {
				this.handlers[key] = customHandlers[key];
			}
		}

	}

	fetch(reset) {

		if (reset === undefined) {
			reset = false;
		}

		this.config.itemListingActions.classList.add("loading");
		this.config.mobileMenuActivityArea.classList.add("loading");

		const filtersObject = this.handlers.filterHandler.getCurrentFilter();

		if (this.state.currentIndex === 0) {
			this.state.currentIndex = Number(filtersObject.startIndex) + this.state.itemsPerPage;
		} else {
			this.state.currentIndex = this.state.currentIndex + this.state.itemsPerPage;
		}

		const itemListing = document.querySelector(this.config.listingSelector);

		if (reset) {
			this.state.currentIndex = 0;
			this.state.lazyLoadCounter = 0;
			this.config.itemListingActions.classList.remove("done");
			while (itemListing.firstChild) {
				itemListing.removeChild(itemListing.firstChild);
			}

		}

		filtersObject.startIndex = this.state.currentIndex;
		filtersObject.itemsPerPage = this.state.itemsPerPage;

		const request = new XMLHttpRequest();

		if (this.config.ajaxMode === "GET") {
			request.open("GET", this.config.endpoint + "?filters=" + encodeURIComponent(btoa(JSON.stringify(filtersObject))), true);
		} else {
			request.open("POST", this.config.endpoint, true);
			request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
		}

		request.onload = () => {
			if (request.status >= 200 && request.status < 400) {
				const result = request.responseText;
				const feetched = JSON.parse(result);
				this.config.itemListingActions.classList.remove("loading");
				this.config.mobileMenuActivityArea.classList.remove("loading");

				if (feetched.done === true) {
					this.state.done = true;
					this.config.itemListingActions.classList.add("done");
				} else {
					this.config.itemListingActions.classList.remove("done");
				}

				this.handlers.actions.updateListingCount(feetched.totalItemCount);
				this.state.nextPage++;
				this.handlers.actions.setNextPage(this.state.nextPage);

				const newItems = document.createElement("div");
				newItems.innerHTML = feetched.items;

				// Add elements one by one.
				while (newItems.firstChild) {
					itemListing.appendChild(newItems.firstChild);
				}
			} else {
				this.state.lazyLoadCounter = this.state.lazyLoadingTimes + 1;
				console.log("Couldn't load items.");
				itemListing.innerHTML = this.config.noListingItems;
				this.config.itemListingActions.classList.remove("loading");
				this.config.itemListingActions.classList.add("done");
				this.config.mobileMenuActivityArea.classList.remove("loading");
			}
		};

		request.onerror = () => {
			this.state.lazyLoadCounter = this.state.lazyLoadingTimes + 1;
			console.log("Couldn't load items.");
			itemListing.innerHTML = this.config.noListingItems;
			this.config.itemListingActions.classList.remove("loading");
			this.config.itemListingActions.classList.add("done");
			this.config.mobileMenuActivityArea.classList.remove("loading");
		};

		if (this.config.ajaxMode === "GET") {
			request.send();
		} else {
			request.send("filters=" + JSON.stringify(filtersObject));
		}
	}
}

export default ItemFetcherHandler;
